import Layout from "../layouts/layout";
import styles from "../styles/_screens/editContent.module.scss";

const EditContent = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <h1>Main Page Content - Welcome</h1>

        <div className={styles.field}>
          <h3>Title - Welcome</h3>
          <input type="text" name="welcomeTitle" />
        </div>

        <div className={styles.field}>
          <h3>Content - Welcome</h3>
          <textarea name="welcomeContent"></textarea>
        </div>

        <div className={styles.field}>
          <h3>Message to the audience (usually coupons)</h3>
          <textarea name="message"></textarea>
        </div>

        <div className={styles.field}>
          <h3>Terms of Use for Purchase</h3>
          <textarea name="terms"></textarea>
        </div>

        <button>Update</button>
      </div>
    </Layout>
  );
};

export default EditContent;
